import {
  ChartBarIcon,
  CurrencyDollarIcon,
  TrophyIcon,
  PuzzlePieceIcon
} from '@heroicons/react/24/outline';
import React from 'react';

const StatsCards = ({ stats }) => {
  const cards = [
    {
      title: 'Total Games',
      value: stats.totalGames,
      icon: PuzzlePieceIcon,
      color: 'blue',
      change: '+12%',
      changeType: 'positive'
    },
    {
      title: 'Win Rate',
      value: `${stats.winRate}%`,
      icon: TrophyIcon,
      color: 'green',
      change: '+5.2%',
      changeType: 'positive'
    },
    {
      title: 'Total Earnings',
      value: `$${stats.totalEarnings.toLocaleString()}`,
      icon: CurrencyDollarIcon,
      color: 'yellow',
      change: '+23%',
      changeType: 'positive'
    },
    // {
    //   title: 'Average Score',
    //   value: stats.averageScore.toLocaleString(),
    //   icon: ChartBarIcon,
    //   color: 'purple',
    //   change: '+8%',
    //   changeType: 'positive'
    // }
  ];

  const getColorClasses = (color) => {
    const colors = {
      blue: 'text-white bg-gradient-to-r from-blue-500 to-blue-600 shadow-lg shadow-blue-500/25',
      green: 'text-white bg-gradient-to-r from-green-500 to-green-600 shadow-lg shadow-green-500/25',
      yellow: 'text-white bg-gradient-to-r from-yellow-500 to-yellow-600 shadow-lg shadow-yellow-500/25',
      purple: 'text-white bg-gradient-to-r from-purple-500 to-purple-600 shadow-lg shadow-purple-500/25'
    };
    return colors[color] || colors.blue;
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6">
      {cards.map((card, index) => {
        const Icon = card.icon;
        return (
          <div
            key={index}
            className="bg-white/70 dark:bg-gray-800/70 backdrop-blur-sm rounded-2xl shadow-xl p-6 border border-white/20 dark:border-gray-700/50 hover:shadow-2xl hover:scale-105 transition-all duration-300"
          >
            <div className="flex items-center">
              <div className={`flex-shrink-0 p-4 rounded-2xl ${getColorClasses(card.color)}`}>
                <Icon className="h-8 w-8" />
              </div>
              <div className="ml-5 flex-1">
                <p className="text-sm font-medium text-gray-500 dark:text-gray-400 uppercase tracking-wide">
                  {card.title}
                </p>
                <div className="flex items-baseline mt-2">
                  <p className="text-3xl font-bold text-gray-900 dark:text-white">
                    {card.value}
                  </p>
                  <span className={`ml-3 text-sm font-semibold px-2 py-1 rounded-full ${
                    card.changeType === 'positive' 
                      ? 'text-green-700 dark:text-green-300 bg-green-100 dark:bg-green-900/30' 
                      : 'text-red-700 dark:text-red-300 bg-red-100 dark:bg-red-900/30'
                  }`}>
                    {card.change}
                  </span>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default StatsCards;
